import template from './lenderDocumentsList.template.html';

export default {
  template,
  bindings: {
    documents: '<',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew, lendersService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.onReady({ list: ctrl.list });
        ctrl.documents = ctrl.documents || [];
        ctrl.list.setOrderBy('getName()');
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.documents, ctrl.list.getGroupingByFirstLetter())
        );
      };

      ctrl.downloadDocument = ({ $event, doc }) => {
        $event.stopPropagation();
        lendersService.getCalculator(doc);
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.documents && changes.documents.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
